import { translateWith } from "lib/core/i18n/i18n.utils"
import { languagePack as rootLanguagePack } from "lib/core/i18n/root.i18"

export const languagePack = {
  ["general-notification"]: {
    nl: `Dit weekend ondervonden we een technische storing. Deze storing werd veroorzaakt
         door problemen bij een externe partij. We hebben deze oorzaak maandagochtend
         geïdentificeerd en verholpen. Onze excuses voor het eventuele ongemak.`,
    en: `On Monday 5 July we experienced a technical failure, which may have caused
         you inconvenience. The cause has now been found and resolved. Our apologies
         for the inconvenience.`,
  },
}

export const t = translateWith(languagePack, rootLanguagePack)
